export class TimeManagerService {
    constructor() {
        // Private properties to store data
        this.serverTime = null;
        this.instance = null;
    }

    /**
     * Static method for async singleton initialization
     * TODO improve this code to make sure that able that the 'serverTime' variable is unic by FormId.
     *  if an 2 async proccess use this instance in same time, you will have a conflict with serverTime variable which
     *  can be delete by deleteInstance method. To avoid this problem pass a formId to getInstance() static method and
     *  make sure to store this instance on an array with this formId key parameters. Refactor also deleteInstance.
     * @returns {Promise<null|TimeManagerService|*>}
     */
    static async getInstance() {
        if (!TimeManagerService.instance) {
            // Create a new instance
            const instance = new TimeManagerService();
            await instance.init(); // Perform async initialization
            TimeManagerService.instance = instance; // Save the instance
        }

        return TimeManagerService.instance;
    }

    // Async method for initialization
    async init() {
        // Simulate an async operation (e.g., fetching from an API)
        this.serverTime = await new Promise(async function(resolve) {
            const response = await fetch('/api/time');
            let serverTime = await response.text();
            console.log("serverTime" + parseInt(serverTime))
            resolve(parseInt(serverTime));
        });
    }

    // Example method to access the data
    getTime() {
        return this.serverTime;
    }

    deleteInstance() {
        TimeManagerService.instance = null
        this.serverTime = null
    }
}

export default TimeManagerService;
